/* ============================================================
   SORLUMA — interacciones (vanilla JS, sin librerías)
   ============================================================ */
(function () {
  "use strict";

  /* Cada sección incluye este archivo, así que el navegador lo ejecuta una vez
     por cada etiqueta <script>. Sin este cerrojo los eventos se enganchaban
     tantas veces como secciones hubiera y los clics se anulaban entre sí. */
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Reveal al hacer scroll (un solo observer compartido) ---- */
  function initReveal() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("mt-visible"); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Contadores animados ---- */
  function initCounters() {
    var nums = document.querySelectorAll("[data-mt-count]");
    if (!nums.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute("data-mt-count"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute("data-mt-count"));
        var dec = (el.getAttribute("data-mt-count").split(".")[1] || "").length;
        var dur = 1600, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(dec);
          if (p < 1) requestAnimationFrame(step); else el.textContent = target.toFixed(dec);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---- Comparador antes/después ---- */
  function initComparador() {
    var sliders = document.querySelectorAll(".mt-comp__slider");
    sliders.forEach(function (s) {
      var before = s.querySelector(".mt-comp__img--before");
      var handle = s.querySelector(".mt-comp__handle");
      var grip = s.querySelector(".mt-comp__grip");
      if (!before || !handle) return;
      var dragging = false;
      function setPos(clientX) {
        var r = s.getBoundingClientRect();
        var x = Math.max(0, Math.min(clientX - r.left, r.width));
        var pct = (x / r.width) * 100;
        before.style.clipPath = "inset(0 " + (100 - pct) + "% 0 0)";
        handle.style.left = pct + "%";
      }
      function down(e) { dragging = true; setPos((e.touches ? e.touches[0] : e).clientX); e.preventDefault(); }
      function move(e) { if (!dragging) return; setPos((e.touches ? e.touches[0] : e).clientX); }
      function up() { dragging = false; }
      (grip || handle).addEventListener("mousedown", down);
      (grip || handle).addEventListener("touchstart", down, { passive: false });
      s.addEventListener("mousedown", down);
      s.addEventListener("touchstart", down, { passive: false });
      window.addEventListener("mousemove", move);
      window.addEventListener("touchmove", move, { passive: true });
      window.addEventListener("mouseup", up);
      window.addEventListener("touchend", up);
    });
  }

  /* ---- Acordeones (FAQ + desplegables de producto) ---- */
  function bindAccordion(item, qSel, aSel) {
    var q = item.querySelector(qSel);
    var a = item.querySelector(aSel);
    if (!q || !a) return;
    if (q.getAttribute("data-mt-bound")) return; // nunca enganchar dos veces
    q.setAttribute("data-mt-bound", "1");
    q.addEventListener("click", function () {
      var open = item.classList.contains("mt-open");
      if (open) {
        item.classList.remove("mt-open");
        a.style.maxHeight = null;
        q.setAttribute("aria-expanded", "false");
      } else {
        item.classList.add("mt-open");
        a.style.maxHeight = a.scrollHeight + "px";
        q.setAttribute("aria-expanded", "true");
      }
    });
    // Si nace abierto, fijamos su altura real y la recalculamos al redimensionar
    if (item.classList.contains("mt-open")) {
      a.style.maxHeight = a.scrollHeight + "px";
    }
    window.addEventListener("resize", function () {
      if (item.classList.contains("mt-open")) a.style.maxHeight = a.scrollHeight + "px";
    });
  }
  function initFaq() {
    document.querySelectorAll(".mt-faq__item").forEach(function (i) { bindAccordion(i, ".mt-faq__q", ".mt-faq__a"); });
    document.querySelectorAll(".mt-acc__item").forEach(function (i) { bindAccordion(i, ".mt-acc__q", ".mt-acc__a"); });
  }

  /* ---- Galería página de producto ---- */
  function initGallery() {
    var gal = document.querySelector(".mt-pdp__gallery");
    if (!gal) return;
    var main = gal.querySelector(".mt-pdp__main img");
    var thumbs = gal.querySelectorAll(".mt-pdp__thumb");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var full = t.getAttribute("data-full");
        if (full) main.src = full;
        thumbs.forEach(function (x) { x.classList.remove("mt-active"); });
        t.classList.add("mt-active");
      });
    });
  }

  /* ---- Variantes página de producto ---- */
  function initVariants() {
    var form = document.querySelector(".mt-pdp__form");
    var dataEl = document.getElementById("mt-variant-data");
    if (!form || !dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var swatches = document.querySelectorAll(".mt-pdp__swatch");
    var priceNow = document.querySelector(".mt-pdp__price-now");
    var addBtn = form.querySelector('button[name="add"]');
    if (!swatches.length) return;
    swatches.forEach(function (sw) {
      sw.addEventListener("click", function () {
        var vid = sw.getAttribute("data-vid");
        var v = variants.filter(function (x) { return String(x.id) === String(vid); })[0];
        if (!v) return;
        swatches.forEach(function (x) { x.classList.remove("mt-active"); });
        sw.classList.add("mt-active");
        if (idInput) idInput.value = v.id;
        if (priceNow && v.price != null) priceNow.textContent = v.price;
        if (addBtn) {
          if (v.available) { addBtn.disabled = false; addBtn.classList.remove("mt-pdp__sold"); addBtn.textContent = addBtn.getAttribute("data-add") || "Add to cart"; }
          else { addBtn.disabled = true; addBtn.classList.add("mt-pdp__sold"); addBtn.textContent = addBtn.getAttribute("data-sold") || "Sold out"; }
        }
        var buyBtn = document.querySelector(".mt-pdp__buynow");
        if (buyBtn) {
          if (v.available) { buyBtn.disabled = false; buyBtn.classList.remove("mt-pdp__sold"); buyBtn.textContent = buyBtn.getAttribute("data-buy") || "Buy it now"; }
          else { buyBtn.disabled = true; buyBtn.classList.add("mt-pdp__sold"); buyBtn.textContent = buyBtn.getAttribute("data-sold") || "Sold out"; }
        }
      });
    });
  }

  /* ---- Botón "Comprar ahora" (añade y va directo al pago) ---- */
  function initBuyNow() {
    var btn = document.querySelector(".mt-pdp__buynow[data-checkout]");
    var form = document.querySelector(".mt-pdp__form");
    if (!btn || !form) return;
    btn.addEventListener("click", function () {
      if (btn.disabled) return;
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Un momento…";
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: idInput.value, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error("add failed");
        window.location.href = "/checkout";
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = original;
        form.submit();
      });
    });
  }

  /* ---- Vídeo con carga diferida ---- */
  function initVideo() {
    var vids = document.querySelectorAll("[data-mt-video]");
    if (!vids.length) return;
    vids.forEach(function (v) {
      var wrap = v.closest(".mt-vid__frame") || v.parentElement;
      var btn = wrap ? wrap.querySelector("[data-mt-video-play]") : null;
      var cargado = false;

      function cargar() {
        if (cargado) return;
        cargado = true;
        v.preload = "auto";
        v.load();
      }
      function reproducir() {
        cargar();
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }

      if (btn) {
        btn.addEventListener("click", function () {
          if (v.paused) { reproducir(); } else { v.pause(); }
        });
        v.addEventListener("play", function () { wrap.classList.add("mt-playing"); });
        v.addEventListener("pause", function () { wrap.classList.remove("mt-playing"); });
      }

      if (reduce || !("IntersectionObserver" in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { reproducir(); }
          else if (cargado && !v.paused) { v.pause(); }
        });
      }, { threshold: 0.35 });
      io.observe(v);
    });
  }

  /* ---- Reseñas: cálculo, filtros, orden y paginación ---- */
  function initOpiniones() {
    var raiz = document.querySelector("[data-mt-op]");
    var dataEl = document.querySelector("[data-mt-op-data]");
    if (!raiz || !dataEl) return;

    var todas = [];
    try { todas = JSON.parse(dataEl.textContent.trim() || "[]"); } catch (e) { todas = []; }
    if (!Array.isArray(todas)) todas = [];

    // Normalizamos y descartamos entradas sin puntuación válida
    todas = todas.map(function (o) {
      return {
        n: (o.n || "Anonymous") + "",
        r: Math.max(1, Math.min(5, parseInt(o.r, 10) || 0)),
        d: o.d || "",
        t: o.t || "",
        c: o.c || "",
        v: o.v !== false,
        f: o.f || "",
        p: parseInt(o.p, 10) || 0,
        img: o.img || ""
      };
    }).filter(function (o) { return o.r >= 1 && o.c; });

    var base = raiz.getAttribute("data-asset-base") || "";
    var porPagina = parseInt(raiz.getAttribute("data-por-pagina"), 10) || 8;
    var txtVerificada = raiz.getAttribute("data-txt-verificada") || "Compra verificada";
    var txtVacio = raiz.getAttribute("data-txt-vacio") || "No reviews match this filter.";

    var total = todas.length;
    var suma = todas.reduce(function (a, o) { return a + o.r; }, 0);
    var media = total ? (suma / total) : 0;
    var mediaTxt = media.toFixed(1);

    /* --- Utilidades --- */
    function estrellas(valor) {
      var pct = Math.max(0, Math.min(100, (valor / 5) * 100));
      return '<span class="mt-stars"><span class="mt-stars__bg">★★★★★</span><span class="mt-stars__fill" style="width:' + pct + '%">★★★★★</span></span>';
    }
    function fecha(iso) {
      if (!iso) return "";
      var d = new Date(iso);
      if (isNaN(d.getTime())) return iso;
      try {
        return d.toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" });
      } catch (e) { return iso; }
    }
    function esc(s) {
      return (s + "").replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }
    function iniciales(nombre) {
      var p = (nombre || "?").trim().split(/\s+/);
      return ((p[0] || "?")[0] + (p[1] ? p[1][0] : "")).toUpperCase();
    }
    function plural(n, uno, varios) { return n === 1 ? uno : varios; }
    var txtResena = raiz.getAttribute("data-txt-resena") || "review";
    var txtResenas = raiz.getAttribute("data-txt-resenas") || "reviews";

    /* --- Resumen global --- */
    var elAvg = raiz.querySelector("[data-mt-op-avg]");
    var elAvgStars = raiz.querySelector("[data-mt-op-avg-stars]");
    var elTotal = raiz.querySelector("[data-mt-op-total]");
    if (elAvg) elAvg.textContent = total ? mediaTxt : "—";
    if (elAvgStars) elAvgStars.innerHTML = estrellas(media);
    if (elTotal) elTotal.textContent = total + " " + plural(total, txtResena, txtResenas);

    /* --- Desglose por estrellas --- */
    var bars = raiz.querySelector("[data-mt-op-bars]");
    if (bars) {
      var html = "";
      for (var s = 5; s >= 1; s--) {
        var n = todas.filter(function (o) { return o.r === s; }).length;
        var pct = total ? Math.round((n / total) * 100) : 0;
        html += '<button type="button" class="mt-op__bar" role="listitem" data-mt-op-filtro="' + s + '">' +
          '<span class="mt-op__bar-lbl">' + s + ' ★</span>' +
          '<span class="mt-op__bar-track"><span class="mt-op__bar-fill" style="width:' + pct + '%"></span></span>' +
          '<span class="mt-op__bar-num">' + n + '</span></button>';
      }
      bars.innerHTML = html;
    }

    /* --- Sincronizamos la valoración de la cabecera del producto --- */
    document.querySelectorAll("[data-mt-rating]").forEach(function (w) {
      if (!total) { w.hidden = true; return; }
      var a = w.querySelector("[data-mt-rating-avg]");
      var st = w.querySelector("[data-mt-rating-stars]");
      var c = w.querySelector("[data-mt-rating-count]");
      if (a) a.textContent = mediaTxt;
      if (st) st.innerHTML = estrellas(media);
      if (c) c.textContent = "· " + total + " " + plural(total, txtResena, txtResenas);
      w.hidden = false;
    });

    /* --- Estado --- */
    var filtro = "todas";
    var orden = "recientes";
    var visibles = porPagina;

    function filtradas() {
      var l = todas.slice();
      if (filtro === "foto") l = l.filter(function (o) { return o.img; });
      else if (filtro !== "todas") l = l.filter(function (o) { return o.r === parseInt(filtro, 10); });

      l.sort(function (a, b) {
        if (orden === "mejor") return b.r - a.r || (b.d > a.d ? 1 : -1);
        if (orden === "peor") return a.r - b.r || (b.d > a.d ? 1 : -1);
        if (orden === "antiguas") return (a.d > b.d ? 1 : a.d < b.d ? -1 : 0);
        // Orden por defecto: las destacadas primero, luego por fecha
        if (a.p !== b.p) return b.p - a.p;
        return (a.d < b.d ? 1 : a.d > b.d ? -1 : 0);
      });
      return l;
    }

    var lista = raiz.querySelector("[data-mt-op-lista]");
    var btnMas = raiz.querySelector("[data-mt-op-mas]");
    var contador = raiz.querySelector("[data-mt-op-contador]");

    function pintar() {
      var l = filtradas();
      var trozo = l.slice(0, visibles);

      if (!trozo.length) {
        lista.innerHTML = '<p class="mt-op__vacio">' + esc(txtVacio) + "</p>";
      } else {
        lista.innerHTML = trozo.map(function (o) {
          var img = o.img
            ? '<div class="mt-op__foto"><img src="' + (/^https?:|^\//.test(o.img) ? o.img : base + o.img) + '" alt="Customer photo of the Sorluma migraine cap" loading="lazy" decoding="async"></div>'
            : "";
          return '<article class="mt-op__card">' +
            '<div class="mt-op__card-top">' +
              '<span class="mt-op__avatar" aria-hidden="true">' + esc(iniciales(o.n)) + "</span>" +
              '<div class="mt-op__who"><span class="mt-op__nombre">' + esc(o.n) + "</span>" +
                (o.f
                  ? '<span class="mt-op__fuente">' + esc(o.f) + "</span>"
                  : (o.v ? '<span class="mt-op__ver"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' + esc(txtVerificada) + "</span>" : "")) +
              "</div>" +
              '<span class="mt-op__card-stars" aria-label="' + o.r + ' de 5">' + estrellas(o.r) + "</span>" +
            "</div>" +
            (o.t ? '<h4 class="mt-op__t">' + esc(o.t) + "</h4>" : "") +
            '<p class="mt-op__c">' + esc(o.c) + "</p>" +
            img +
            '<time class="mt-op__fecha" datetime="' + esc(o.d) + '">' + esc(fecha(o.d)) + "</time>" +
            "</article>";
        }).join("");
      }

      if (btnMas) btnMas.hidden = trozo.length >= l.length;
      if (contador) contador.textContent = l.length ? "Mostrando " + trozo.length + " de " + l.length : "";
    }

    raiz.addEventListener("click", function (e) {
      var f = e.target.closest("[data-mt-op-filtro]");
      if (f) {
        filtro = f.getAttribute("data-mt-op-filtro");
        visibles = porPagina;
        raiz.querySelectorAll(".mt-op__chip").forEach(function (c) {
          c.classList.toggle("mt-active", c.getAttribute("data-mt-op-filtro") === filtro);
        });
        pintar();
        return;
      }
      if (e.target.closest("[data-mt-op-mas]")) { visibles += porPagina; pintar(); }
    });

    var sel = raiz.querySelector("[data-mt-op-orden]");
    if (sel) sel.addEventListener("change", function () { orden = sel.value; visibles = porPagina; pintar(); });

    /* --- Formulario --- */
    var form = raiz.querySelector("[data-mt-op-form]");
    if (form) {
      if (window.location.hash === "#mt-op-form" || form.querySelector(".mt-op__msg--ok")) form.hidden = false;
      raiz.querySelectorAll("[data-mt-op-open]").forEach(function (b) {
        b.addEventListener("click", function () {
          form.hidden = false;
          form.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" });
          var f = form.querySelector("input[type=text]");
          if (f) setTimeout(function () { f.focus(); }, reduce ? 0 : 420);
        });
      });
      raiz.querySelectorAll("[data-mt-op-cerrar]").forEach(function (b) {
        b.addEventListener("click", function () { form.hidden = true; });
      });
    }

    pintar();
  }

  /* ---- Seguimiento de pedido ---- */
  function initTracking() {
    document.querySelectorAll("[data-mt-track-go]").forEach(function (btn) {
      var panel = btn.closest(".mt-track__opt-body") || document;
      var input = panel.querySelector("[data-mt-track-input]");
      var err = panel.querySelector("[data-mt-track-err]");
      if (!input) return;
      function ir() {
        var val = (input.value || "").trim();
        if (!val) {
          if (err) err.hidden = false;
          input.focus();
          return;
        }
        if (err) err.hidden = true;
        var base = input.getAttribute("data-mt-track-url") || "https://t.17track.net/es#nums=";
        window.open(base + encodeURIComponent(val), "_blank", "noopener");
      }
      btn.addEventListener("click", ir);
      input.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); ir(); } });
      input.addEventListener("input", function () { if (err) err.hidden = true; });
    });
  }

  function boot() {
    /* Cada init va aislado: si uno falla en un navegador concreto,
       los demás siguen funcionando. */
    var tareas = [initReveal, initCounters, initComparador, initFaq, initGallery,
                  initVariants, initBuyNow, initVideo, initTracking, initOpiniones];
    for (var i = 0; i < tareas.length; i++) {
      try { tareas[i](); } catch (e) {
        if (window.console && console.error) console.error("[Sorluma]", tareas[i].name, e);
      }
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
